import { lazier } from '@shared/components';

import ProfilePagePlaceholder from './ProfilePagePlaceholder';

export { ProfilePagePlaceholder };

export const ProfilePage = lazier(
  () => import('./ProfilePage'),
  ProfilePagePlaceholder,
);

export const OwnActivityLogsPage = lazier(
  () => import('./OwnActivityLogsPage'),
  ProfilePagePlaceholder,
);
